export default __webpack_public_path__ + "static/media/394160__vacuumfan7072__uiclick4.2a957204.mp3";